import React from "react";
import SectionsConfigurator from "../SectionsConfigurator";

// Matches the Roads & Sewers workflow's stepper order (StepperNavigation.tsx).
export const ROADS_SEWERS_SECTIONS = [
  "Preliminary Items",
  "Foul Sewers",
  "Storm Sewers",
  "Roads",
  "Main Services & Substation Base",
  "POS",
  "Spoil Reconciliation",
  "Compound",
];

interface RoadsSewersTakeoffConfigProps {
  onChangeJobType: () => void;
}

const RoadsSewersTakeoffConfig: React.FC<RoadsSewersTakeoffConfigProps> = ({ onChangeJobType }) => (
  <SectionsConfigurator
    jobType="roadsAndSewers"
    jobTypeLabel="Roads & Sewers"
    sections={ROADS_SEWERS_SECTIONS}
    onChangeJobType={onChangeJobType}
  />
);

export default RoadsSewersTakeoffConfig;
